import type { HTMLAttributeAnchorTarget } from 'react'
import React from 'react'

import type { LinkPreviewModel } from '@oneToOne/shared/components/LinkPreview'

import type { PIPParams } from '@core/pictureInPicture/types'

export interface TextSnippet {
  id: string
  shortcut: string
  content: string
}

export type ChatContextProps = {
  enableLink: boolean
  linkTarget?: HTMLAttributeAnchorTarget
  pipParams?: PIPParams
  onClose?: () => void
  textSnippets?: Array<TextSnippet>
  trackLinkPreviewClick?: (linkPreview: LinkPreviewModel) => void
  trackLinkPreviewImpression?: (linkPreview: LinkPreviewModel) => void
}

export const ChatContext = React.createContext<ChatContextProps>({
  enableLink: false,
  linkTarget: undefined,
  pipParams: undefined,
  onClose: undefined,
  textSnippets: [],
})
